module.exports = __webpack_public_path__ + "static/media/halfPage.356fe8db.jpg";